import { Suspense } from 'react';

import { lazyRoute } from 'src/routes/lazy-route';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

import { CheckoutProvider } from 'src/sections/customer/checkout/context';
import { ActingClientProvider, ActingClientGate } from 'src/sections/customer/acting-client';

import CustomerGuard from 'src/auth/guard/customer-guard';
import AdminAgentOrCusotmerGuard from 'src/auth/guard/admin-agent-customer-guard';

import { paths } from '../paths';

// ----------------------------------------------------------------------

// OVERVIEW
// const IndexPage = lazyRoute(() => import('src/pages/dashboard/app'));

const CatalogShopPage = lazyRoute(() => import('src/pages/customer/catalog'));
const CheckoutPage = lazyRoute(() => import('src/pages/customer/checkout'));
const PaymentStatusPage = lazyRoute(() => import('src/pages/customer/payment-status'));
const OrderListPage = lazyRoute(() => import('src/pages/customer/orders/order-list'));
const OrderDetailsPage = lazyRoute(() => import('src/pages/customer/orders/details'));
const ProducerListPage = lazyRoute(() => import('src/pages/customer/producer-list'));
// ----------------------------------------------------------------------

export const customerRoutes = [
  {
    element: (
      <AuthGuard>
        {/* NAT-2497: the gate sits ABOVE the checkout provider, whose cart and
            current-order fetches fire on mount — a customer with no venue, or
            with several and none chosen, must issue no client-scoped request. */}
        <ActingClientProvider>
          <ActingClientGate>
            <CheckoutProvider>
              <DashboardLayout>
                <Suspense fallback={<LoadingScreen />}>
                  <Outlet />
                </Suspense>
              </DashboardLayout>
            </CheckoutProvider>
          </ActingClientGate>
        </ActingClientProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.customer.catalog,
        element: (
          <AdminAgentOrCusotmerGuard>
            <CatalogShopPage />
          </AdminAgentOrCusotmerGuard>
        ),
      },
      {
        path: paths.customer.checkout,
        element: (
          <AdminAgentOrCusotmerGuard>
            <CheckoutPage />
          </AdminAgentOrCusotmerGuard>
        ),
      },
      {
        path: paths.customer.orders.root,
        element: (
          <CustomerGuard>
            <OrderListPage />
          </CustomerGuard>
        ),
      },
      {
        path: paths.customer.orders.details(':order_code'),
        element: (
          <CustomerGuard>
            <OrderDetailsPage />
          </CustomerGuard>
        ),
      },
      {
        path: paths.customer.producers,
        element: (
          <CustomerGuard>
            <ProducerListPage />
          </CustomerGuard>
        ),
      },
    ],
  },
  {
    element: (
      <AuthGuard>
        {/* NAT-2497: the payment return page acts for a venue too — the provider
            (no gate) hands it the tab's selection back after the Stripe round trip. */}
        <ActingClientProvider>
          <CheckoutProvider>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </CheckoutProvider>
        </ActingClientProvider>
      </AuthGuard>
    ),
    children: [{ path: paths.customer.paymentStatus, element: <PaymentStatusPage /> }],
  },
];
